// Central content for Sabala Management LLC marketing site
export const LOGO_URL = "/sabala-logo.png";

export const IMAGES = {
  govBuilding:
    "https://images.unsplash.com/photo-1616873354936-b9e21b744c54?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmclMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzNTQxMzYyfDA&ixlib=rb-4.1.0&q=85",
  blueprint:
    "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxlbmdpbmVlcmluZyUyMGNvbnN0cnVjdGlvbiUyMGJsdWVwcmludCUyMHByZWNpc2lvbnxlbnwwfHx8fDE3ODM1NDEzNjJ8MA&ixlib=rb-4.1.0&q=85",
  facility:
    "https://images.unsplash.com/photo-1648599107420-ef20db016126?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtaWxpdGFyeSUyMG1vZHVsYXIlMjBidWlsZGluZyUyMGZhY2lsaXR5fGVufDB8fHx8MTc4MzU0MTM2Mnww&ixlib=rb-4.1.0&q=85",
};

export const HERO = {
  eyebrow: "Women-Owned Small Business · SBA 8(a) Certified",
  lines: ["Modular facilities", "built for the", "mission."],
  subtitle:
    "Design-build construction, mission-critical infrastructure, and secure facilities delivered for Federal agencies and the Department of Defense.",
};

export const CERTIFICATIONS = [
  {
    code: "WOSB",
    title: "WOSB Certified",
    desc: "Federally recognized Women-Owned Small Business, qualifying for set-aside contracting opportunities across government agencies.",
  },
  {
    code: "8(a)",
    title: "SBA 8(a) Certified",
    desc: "Certified under the SBA 8(a) Business Development program for small, disadvantaged businesses competing for federal contracts.",
  },
  {
    code: "ICD 705",
    title: "ICD 705 Certifications",
    desc: "Qualified for the construction and accreditation of Sensitive Compartmented Information Facilities (SCIFs) to intelligence-community standards.",
  },
  {
    code: "SAP",
    title: "SAP Certifications",
    desc: "Special Access Program certified — cleared to build and manage facilities requiring elevated security controls and access protocols.",
  },
  {
    code: "CMMC L2",
    title: "C3PAO Level 2 CMMC Certified",
    desc: "Cybersecurity Maturity Model Certification Level 2, protecting controlled unclassified information across the Defense Industrial Base.",
  },
  {
    code: "USACE",
    title: "USACE QCM Certified",
    desc: "U.S. Army Corps of Engineers Quality Control Management certified, ensuring rigorous three-phase quality control on every project.",
  },
  {
    code: "OSHA",
    title: "OSHA Compliant Safety Program",
    desc: "A fully documented, OSHA-compliant safety program governing every site, protecting personnel and maintaining zero-incident standards.",
  },
];

export const COMPETENCIES = [
  "SAPF & SCIF Design",
  "Design-Build Construction",
  "Modular & Prefab Solutions",
  "USACE QCM Processes",
  "Civil & Structural Engineering",
  "Security Systems",
  "Project Management",
  "Logistics & Transportation",
  "Facility Commissioning",
  "MEP Construction",
  "Mission-Specific Projects",
  "Bonding",
];

// Full core-competencies list for the printable Capability Statement (matches PDF)
export const STATEMENT_COMPETENCIES = [
  "SAPF & SCIF Design & Construction",
  "Design-Build Construction",
  "Modular & Prefabricated Solutions",
  "USACE QCM Processes",
  "Site Safety",
  "Three Phase Quality Control System",
  "Civil & Structural Engineering",
  "Communication and Security Systems",
  "Project Management",
  "Logistics & Transportation",
  "Facility Commissioning",
  "MEP Construction and Engineering",
  "Mission Specific Projects",
  "Modular Facility Solutions",
  "Bonding",
];

// Certification labels as they appear on the statement
export const STATEMENT_CERTS = [
  "WOSB Certified",
  "SBA 8(a) Certified",
  "ICD 705 Certifications",
  "SAP Certifications",
  "C3PAO Level 2 CMMC Certified",
  "USACE QCM Certified",
  "OSHA Compliant Safety Program",
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Turnkey delivery, end to end",
    body: "From planning and engineering to manufacturing, site development, utility infrastructure, quality control, and commissioning — we own the entire lifecycle so our clients don't have to coordinate a dozen vendors.",
  },
  {
    num: "02",
    title: "Rapid response, without compromise",
    body: "We mobilize modular and prefabricated solutions to meet aggressive federal timelines while maintaining strict compliance with construction standards, safety, and quality management.",
  },
  {
    num: "03",
    title: "Secure by design",
    body: "SAPF, SCIF, and CMMC Level 2 expertise is built into our process — we protect systems, information, and mission-critical operations at every phase.",
  },
];

export const PROJECTS = [
  {
    title: "United States Air Force",
    tag: "Department of Defense",
    desc: "Design-build and modular administrative, mission control, and secure facilities supporting active Air Force installations and operational readiness.",
  },
  {
    title: "United States Army",
    tag: "Department of Defense",
    desc: "Turnkey modular and prefabricated facility solutions delivered to Army requirements — from site development through commissioning.",
  },
  {
    title: "U.S. Army Corps of Engineers",
    tag: "USACE",
    desc: "Construction management executed to USACE Quality Control Management (QCM) standards, with rigorous three-phase quality control and safety compliance.",
  },
  {
    title: "Federal Agencies",
    tag: "Government-Wide",
    desc: "Secure facility construction, SCIF/SAPF-capable builds, and rapid-response modular infrastructure for Federal customers requiring compliant, mission-ready delivery.",
  },
];

export const TEAM = [
  {
    name: "Christina Alley",
    role: "Owner & President",
    bio: "Christina provides the strategic leadership that drives our company's success. With a background in psychology and years of executive management experience, she oversees company operations, financial planning, business development, and long-term growth. Her dedication to building strong partnerships, supporting clients, and maintaining the highest standards of integrity ensures every project is guided with professionalism and a commitment to excellence.",
  },
  {
    name: "Markus Alley",
    role: "Project Manager",
    bio: "Markus oversees projects from initial planning through final completion, ensuring every phase is executed efficiently and to the highest standards. With extensive experience in project coordination, operations, government contracting, and team leadership, he manages schedules, resources, and client communication while keeping projects on time and within budget. His commitment to quality, organization, and client satisfaction ensures successful outcomes on every project.",
  },
  {
    name: "Steven Alley",
    role: "Business Development Manager",
    bio: "Steven has extensive experience in business development, project management, and strategic partnerships. With a background in the building products and construction industry, he specializes in fostering strong client relationships, leading teams, and delivering innovative solutions that drive successful projects. His commitment to quality, leadership, and customer satisfaction ensures every client receives exceptional service.",
  },
  {
    name: "John Alley",
    role: "Operations Manager",
    bio: "John combines technical expertise with strong leadership to keep projects secure, organized, and on schedule. He oversees project planning, coordinates teams, and implements cybersecurity best practices to protect our systems and client information. His attention to detail, problem-solving abilities, and commitment to excellence ensure every project is completed efficiently, securely, and to the highest standard.",
  },
  {
    name: "Dean Briggs",
    role: "Structural/Civil Engineer",
    bio: "Dean brings decades of experience in structural and civil engineering to every project. As a licensed Professional Engineer, he ensures every building is designed to meet applicable building codes, regulatory requirements, and industry standards. His expertise in engineering, code compliance, and construction oversight helps deliver safe, efficient, and high-quality solutions that provide lasting value for our clients.",
  },
  {
    name: "Kelly Daniels",
    role: "Design Manager",
    bio: "Kelly brings decades of experience in commercial modular building design and construction planning. He leads the design process from concept through production, developing code-compliant plans, coordinating state approvals, and ensuring every project meets client expectations. His expertise in construction documentation, building codes, and project coordination helps deliver efficient, high-quality designs that support successful project execution.",
  },
];

export const GOAL = {
  eyebrow: "Our Goal",
  title: "Deliver mission-ready facilities that agencies can trust.",
  body: "We exist to give Federal agencies and the Department of Defense a partner who delivers integrated construction solutions with process excellence — efficiency, transparency, safety, security, and uncompromising quality control. Every engagement is measured by one standard: did we complete it with quality, efficiency, and integrity.",
};

export const CONTACT_INFO = {
  address: "961 North Shadowridge Ave., Eagle, Idaho 83616",
  people: [
    { name: "Steven Alley", title: "Business Development", email: "Steven@sabalamgmt.com", phone: "(208) 921-0568" },
    { name: "Markus Alley", title: "Project Manager", email: "Markus@sabalamgmt.com", phone: "(208) 941-9726" },
  ],
  cage: "7N2H5",
  uei: "MCPBDK9HU9T3",
  duns: "080218392",
  gsa: "47QSMS25D0048",
};

export const CAPABILITY_OVERVIEW =
  "Turnkey design-build, modular, and secure facility solutions for Federal agencies and the Department of Defense — delivered with rapid execution and strict compliance.";

export const CAPABILITIES = [
  {
    num: "01",
    title: "Integrated Construction Solutions",
    body: "Sabala Management LLC is a Women-Owned Small Business (WOSB) and SBA 8(a) certified contractor specializing in design-build construction, modular facilities, mission-critical infrastructure, secure facilities, and construction management for Federal agencies and the Department of Defense. Our team delivers turnkey solutions including planning, engineering, manufacturing, site development, utility infrastructure, quality control, and facility commissioning. With extensive experience supporting Air Force, Army, and Federal customers, we provide rapid project delivery while maintaining strict compliance with Federal construction standards, safety requirements, and quality management practices.",
  },
  {
    num: "02",
    title: "Process Excellence",
    body: "Through our performance-based processes we ensure efficiency, transparency, safety, security and quality control. We pride ourselves on communication and transparency throughout the project, ensuring the project continues to progress and move forward efficiently.",
  },
  {
    num: "03",
    title: "Unparalleled USACE QCM Program",
    body: "Sabala Management LLC maintains USACE Construction Quality Management (QCM) certified personnel and utilizes proven quality control procedures to ensure compliance with contract specifications, UFC requirements, EM 385-1-1 safety standards, and Federal quality assurance programs.",
  },
  {
    num: "04",
    title: "Partner Network",
    body: "Sabala Management LLC has gained a wide variety of partners across the US that bring the most knowledge to their given field. This allows us to solve and offer knowledgeable solutions efficiently without delay.",
  },
];
